import clsx from 'clsx';

import {Text} from '../Text';

import {Icon} from './Icon';
import {severityIcons, hollowSeverityIcons} from './severity';

import type {Severity} from '../../types';
import type {FontAwesomeIconProps} from '@fortawesome/react-fontawesome';

type Props = Omit<FontAwesomeIconProps, 'icon'> & {
  severity: Severity;
  isArchived: boolean;
  isHollow?: boolean;
  children?: React.ReactNode;
};
export function SeverityIcon({
  severity,
  isArchived,
  isHollow,
  children,
  className,
  ...restProps
}: Props): React.JSX.Element {
  const hasChildren = !!children;
  const icons = isHollow ? hollowSeverityIcons : severityIcons;

  return (
    <Text
      as={isArchived ? 'invalid' : 'body'}
      tag="span"
      title={isArchived ? 'This severity has been deleted.' : undefined}
      className={className}
    >
      <Icon
        {...restProps}
        icon={icons[severity.icon]}
        style={{color: severity.colour}}
        title={hasChildren ? severity.name : ''}
        className={clsx(hasChildren && 'mr-1')}
      />

      {children}
    </Text>
  );
}

SeverityIcon.displayName = 'SeverityIcon';
